<div class="scroll-to-top" [class.scroll-to-top--visible]="showScrollTop" (click)="scrollTop()"></div>
